import React from 'react';
import { LaunchFlagProps } from 'src/app/slice';
import { SuspenseIntroWidgetAnchor } from '../../utils/introWidgetAnchor';
import { Flag, IntroWidgetWrapper } from './styles';

export const LaunchFlag: React.VFC<LaunchFlagProps> = ({
  introWidgetId,
  flag,
}) => (
  <>
    {introWidgetId ? (
      <IntroWidgetWrapper>
        <SuspenseIntroWidgetAnchor id={introWidgetId} />
      </IntroWidgetWrapper>
    ) : flag ? (
      <Flag
        type={flag.type}
        label={flag.label}
        description={flag.description ?? flag.label}
      />
    ) : null}
  </>
);
